import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-seven',
  templateUrl: './home-seven.component.html',
  styleUrls: ['./home-seven.component.scss']
})
export class HomeSevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
